export const TEST_MODE = false;
export const NAVIGATION_CODE_DELIMITER = ".";
export const URL_LEVEL1 = "/startup-scape_sl/";
